module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/cloud2-35ede55ac7d0b63f7a34d31e1d588cbf.png";